import * as Sentry from "@sentry/browser";
import {htmlTreeAsString} from "@sentry/utils/esm/browser";

let isSentryActive = false;
let sentry_configuration_element = document.getElementById('fn_sentry_js_dsn');
if (sentry_configuration_element !== null) {
	let sentry_dsn = sentry_configuration_element.getAttribute('data-dsn');
	let user = JSON.parse(sentry_configuration_element.getAttribute('data-user'));

	let environment = "production";
	if (window.location.href.includes("webovy-servis.com")) {
		environment = 'staging';
	} else if (window.location.href.includes("wsdev.cz")) {
		environment = 'local';
	}

	if (environment === 'production' && sentry_dsn !== null) {
		isSentryActive = true;
		Sentry.init({
			dsn: sentry_dsn,
			integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
			environment: environment,

			// Set tracesSampleRate to 1.0 to capture 100%
			// of transactions for performance monitoring.
			// We recommend adjusting this value in production
			tracesSampleRate: 1.0,

			// Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
			tracePropagationTargets: ["https://www.aukcerostlin.cz"],

			// Capture Replay for 10% of all sessions,
			// plus for 100% of sessions with an error
			replaysSessionSampleRate: 0.1,
			replaysOnErrorSampleRate: 1.0,
			initialScope: (scope) => {
				scope.setTags({'fromJs': true})
				if (user !== null) {
					scope.setUser(user);
				} else {
					scope.setUser(null);
				}
				return scope;
			}
		});
	}
}

import naja from 'naja'
import SmoothScroll from 'smooth-scroll';
import WebFont from 'webfontloader';
import lazyload from './naja.lazyload';
import gtmEventsExtension from "CmsGtm/js/front/gtm";
import WeseusScrollExtension from "CmsCore/js/weseusScroll.naja";
import LoginRegisterModalExtension from "./LoginRegisterModal.naja";
import AdGeneratorExtension from "./adGenerator";
import ProductLikeExtension from "./productLike";
import {CountdownExtension} from "@weseus/cms-core/assets/js/front/countdown";
import initCookiesBox from './cookies-box'
import AutoSubmitExtension from './autosubmit'
import {addMultipleListeners} from "@weseus/cms-core/assets/js/helpers";
import moment from "moment";

naja.registerExtension(lazyload);
naja.registerExtension(LoginRegisterModalExtension);
naja.registerExtension(CountdownExtension);
naja.registerExtension(AutoSubmitExtension);
naja.registerExtension(AdGeneratorExtension);
naja.registerExtension(ProductLikeExtension);

window.Nette = require('nette-forms');

document.documentElement.className = document.documentElement.className.replace("no-js", "js");

WebFont.load({
	google: {
		families: ['Roboto:ital,wght@0,400;0,700;1,400&display=fallback']
	}
});

try {
	if (isSentryActive && window.location.href.includes('osobni-udaje')) {
		let oldValidateForm = window.Nette.validateForm;

		let numberOfClicks = 0;
		let timeOnPage = moment();

		document.addEventListener('click', (e) => {
			if (e.target && e.target.hasAttribute('data-single-click')) {
				let id = htmlTreeAsString(e.target);
				Sentry.addBreadcrumb({
					'category': 'single-click',
					'message': 'click id: ' + id,
					'level': 'info',
				});
			}

			if (e.target && e.target.hasAttribute('data-send-order')) {
				numberOfClicks += 1;

				if ((numberOfClicks % 3) === 0) {
					const form = e.target.form;
					let data = {};
					try {
						let formData = new FormData(form);
						data = Object.fromEntries(formData.entries());
					} catch (e) {

					}

					const scope = new Sentry.Scope();
					scope.setContext('formData', data);
					scope.setContext('numberOfClicks', {'clicks': numberOfClicks});
					let diff = moment().diff(timeOnPage, 'minutes');
					let diffType = 'minutes';
					if (diff === 0) {
						diff = moment().diff(timeOnPage, 'seconds');
						diffType = 'seconds';
					}
					scope.setContext('timeOnPage', {'diff in': diffType, 'diff': diff});
					Sentry.captureMessage('Send order button - ' + numberOfClicks + " clicks.", scope);
				}
			}
		});

		function e1() {
			var u = '', i = 0;
			while (i++ < 36) {
				var c = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'[i - 1], r = Math.random() * 16 | 0,
					v = c == 'x' ? r : (r & 0x3 | 0x8);
				u += (c == '-' || c == '4') ? c : v.toString(16)
			}
			return u;
		}

		window.Nette.validateForm = function (sender, onlyCheck, focus) {
			let result = oldValidateForm.call(this, sender, onlyCheck, focus);

			if (result === false) {
				const form = sender.form || sender;
				let data = {};
				try {
					let formData = new FormData(form);
					data = Object.fromEntries(formData.entries());
				} catch (e) {

				}

				const scope = new Sentry.Scope();
				scope.setTag('validateError', true);

				let errors = {};
				for (let i = 0; i < window.Nette.formErrors.length; i++) {
					let error = window.Nette.formErrors[i];
					errors[error.element.name] = error.message;
				}

				scope.setContext('errors', errors);

				let errorsText = '';
				Object.entries(errors).forEach(([key, value]) => {
					errorsText = errorsText + key + ' - ' + value + " | ";
				});

				scope.setTag('errors', errorsText);

				scope.setContext('formData', data);

				const basketDataElement = document.getElementById('fn_sentry_basket');
				if (basketDataElement !== null) {
					let basketData = JSON.parse(basketDataElement.getAttribute('data-basket'));
					scope.setContext('basket', basketData);
				}

				let errorName = 'Nette validateForm error';
				if (sentry_configuration_element !== null) {
					let user = JSON.parse(sentry_configuration_element.getAttribute('data-user'));
					errorName = errorName + ' - ' + user.email;
				}

				errorName = errorName + ' - ' + e1();
				scope.setTransactionName(errorsText);

				Sentry.captureException(new Error(errorName), scope);
			}

			return result;
		}
	}
} catch (e) {
	console.error(e);
	if (isSentryActive && window.location.href.includes('osobni-udaje')) {
		Sentry.captureException(e);
	}
}

// GTM
naja.registerExtension(gtmEventsExtension);

naja.registerExtension(WeseusScrollExtension, {
	// set header offset
	offset: function (anchor, toggle) {
		const header = document.querySelector('[data-scroll-header]');
		return header ? header.offsetHeight : 200;
	},
});

document.addEventListener('DOMContentLoaded', naja.initialize.bind(naja));
document.addEventListener("DOMContentLoaded", function (event) {

	initCookiesBox();

	// ------------------------------------------------------ //
	// swiper - detect swipe
	// ------------------------------------------------------ //
	var swiper = {

		touchStartX: 0,
		touchEndX: 0,
		minSwipePixels: 30,
		detectionZone: undefined,
		swiperCallback: function () {
		},

		init: function (detectionZone, callback) {
			swiper.swiperCallback = callback;
			detectionZone.addEventListener('touchstart', function (event) {
				swiper.touchStartX = event.changedTouches[0].screenX;
			}, false);
			detectionZone.addEventListener('touchend', function (event) {
				swiper.touchEndX = event.changedTouches[0].screenX;
				swiper.handleSwipeGesture();
			}, false);
		},

		handleSwipeGesture: function () {
			var direction,
				moved;
			if (swiper.touchEndX <= swiper.touchStartX) {
				moved = swiper.touchStartX - swiper.touchEndX;
				direction = "left";
			}
			if (swiper.touchEndX >= swiper.touchStartX) {
				moved = swiper.touchEndX - swiper.touchStartX;
				direction = "right";
			}
			if (moved > swiper.minSwipePixels && direction !== "undefined") {
				swiper.swipe(direction, moved);
			}
		},

		swipe: function (direction, movedPixels) {
			var ret = {};
			ret.direction = direction;
			ret.movedPixels = movedPixels;
			swiper.swiperCallback(ret);
		}
	};

	// ------------------------------------------------------ //
	// Open menu
	// ------------------------------------------------------ //

	if (document.getElementById('fn_menu-btn') && document.getElementById('fn_menu-close') && document.getElementById('fn_overlay') && document.getElementById('fn_menu')) {

		addMultipleListeners(document.getElementById('fn_menu-btn'), ['click', 'touch'], function () {
			document.body.classList.toggle('menu-open');
			document.getElementById('fn_overlay').classList.add('p_overlay--active');
		});

		addMultipleListeners(document.getElementById('fn_menu-close'), ['click', 'touch'], function () {
			document.body.classList.toggle('menu-open');
			document.getElementById('fn_overlay').classList.remove('p_overlay--active');
		});

		document.body.addEventListener('keydown', function (event) {

			if (event.keyCode == 27) {
				document.body.classList.remove('menu-open');
				document.getElementById('fn_overlay').classList.remove('p_overlay--active');
			}

		});

		// ------------------------------------------------------ //
		// Click on overlay
		// ------------------------------------------------------ //

		addMultipleListeners(document.getElementById('fn_overlay'), ['click', 'touch'], function (e) {
			document.body.className = '';
			document.getElementById('fn_overlay').classList.remove('p_overlay--active');
		});

		// swipe
		var swipeZone = document.getElementById('fn_menu');

		swiper.init(swipeZone, function (e) {
			if (e.direction == 'left' && e.movedPixels > 80) {
				document.body.classList.toggle('menu-open');
				document.getElementById('fn_overlay').classList.remove('p_overlay--active');
			}
		});

	}

	// ------------------------------------------------------ //
	// Smooth scroll - scroll to ...
	// ------------------------------------------------------ //

	var scroll = new SmoothScroll();

	var smoothScrollWithoutHash = function (selector, settings) {
		/**
		 * If smooth scroll element clicked, animate scroll
		 */
		var clickHandler = function (event) {

			var toggle = event.target.closest(selector);
			if (!toggle || toggle.tagName.toLowerCase() !== 'a') return;

			var anchor = document.querySelector(toggle.hash);
			if (!anchor) return;

			event.preventDefault(); // Prevent default click event
			scroll.animateScroll(anchor, toggle, settings || {}); // Animate scroll
		};

		window.addEventListener('click', clickHandler, false);
	};

	// Run our function
	smoothScrollWithoutHash('.fn_scroll');

	// category scroll
	if (window.matchMedia("(max-width: 767px)").matches) {
		const btnScrolls = document.querySelectorAll('.c_mobile-btns button');
		btnScrolls.forEach((btnScroll) => {
			addMultipleListeners(btnScroll, ['click', 'touch'], function (e) {
				const btnTarget = btnScroll.dataset.target;

				setTimeout(function () {
					const divTarget = document.querySelector(btnTarget);
					if (divTarget.classList.contains('show')) {
						scroll.animateScroll(document.querySelector(btnTarget));
					}
				}, 1000);
			});
		});
	}

	// ------------------------------------------------------ //
	// Password switch pass/text ...
	// ------------------------------------------------------ //

	let input = document.querySelector('#fn_show-pass-input');
	let toggleButton = document.querySelector('#fn_show-pass');

	if (toggleButton) {

		toggleButton.addEventListener('click', () => {
			if (input.type === 'password') {
				input.type = 'text';
			} else {
				input.type = 'password';
			}
		});

	}


	// ------------------------------------------------------ //
	// OTP
	// ------------------------------------------------------ //

	if ('OTPCredential' in window) {
		const input = document.querySelector('input[autocomplete="one-time-code"]');
		if (!input) return;
		// Cancel the WebOTP API if the form is submitted manually.
		const ac = new AbortController();
		const form = input.closest('form');
		if (form) {
			form.addEventListener('submit', e => {
				// Cancel the WebOTP API.
				ac.abort();
			});
		}
		// Invoke the WebOTP API
		navigator.credentials.get({
			otp: { transport:['sms'] },
			signal: ac.signal
		}).then(otp => {
			input.value = otp.code;
			// Automatically submit the form when an OTP is obtained.
			if (form) form.submit();
		}).catch(err => {
			console.log(err);
		});
	}

	// ------------------------------------------------------ //
	// plus / minus
	// ------------------------------------------------------ //
	document.addEventListener('click', function (e) {
		if (e.target.hasAttribute('data-plus')) {
			e.preventDefault();
			let input = document.getElementById(e.target.getAttribute('data-plus'));
			let value = parseInt(input.value) + 1;
			if (input.max !== undefined) {
				value = Math.min(value, parseInt(input.max));
			}
			input.value = value;
		}
		else if (e.target.hasAttribute('data-minus')) {
			e.preventDefault();
			let input = document.getElementById(e.target.getAttribute('data-minus'));
			let value = parseInt(input.value) - 1;
			if (input.min !== undefined) {
				value = Math.max(value, parseInt(input.min));
			}
			input.value = value;
		}
	});

});